/**
 * Determines if a series/event has a primary speaker based on lecture distribution
 * Returns speaker name if they give ≥80% of lectures, otherwise null
 * @param {Array} lectures - Array of lecture objects with speaker property
 * @returns {string|null} Primary speaker name or null if no dominant speaker
 */
export function getPrimarySpeaker(lectures) {
  if (!lectures || lectures.length === 0) {
    return null;
  }

  // Count lectures per speaker
  const speakerCounts = lectures.reduce((acc, lecture) => {
    const speaker = lecture.speaker || 'Unknown Speaker';
    acc[speaker] = (acc[speaker] || 0) + 1;
    return acc;
  }, {});

  // Find the speaker with the most lectures
  const sortedSpeakers = Object.entries(speakerCounts)
    .sort((a, b) => b[1] - a[1]); // Sort by count descending

  if (sortedSpeakers.length === 0) {
    return null;
  }

  const [topSpeaker, topCount] = sortedSpeakers[0];

  // Check if the top speaker has ≥80% of lectures
  const percentage = topCount / lectures.length;
  
  return percentage >= 0.8 ? topSpeaker : null;
}

/**
 * Gets subtitle text for an event card based on speaker dominance
 * @param {Array} lectures - Array of lecture objects
 * @returns {string} Subtitle text showing primary speaker or "Multiple speakers"
 */
export function getEventSubtitle(lectures) {
  const primarySpeaker = getPrimarySpeaker(lectures);
  return primarySpeaker || 'Multiple speakers';
}